import { motion } from "framer-motion";
import { Phone, ArrowRight } from "lucide-react";
import { scrollToId, PHONE_DISPLAY, PHONE_TEL } from "@/lib/scroll";

export const CTABand = () => (
  <section data-testid="cta-band" className="relative overflow-hidden border-y border-white/10 bg-surface">
    <div className="absolute -right-40 top-0 h-[360px] w-[360px] rounded-full bg-brand/10 blur-[130px]" aria-hidden="true" />
    <div className="relative mx-auto max-w-7xl px-5 md:px-8 py-16 md:py-24 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-10">
      <motion.div
        initial={{ opacity: 0, y: 28 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.6 }}
      >
        <p className="mb-3 text-xs font-bold tracking-[0.3em] text-brand-bright">KOSTENLOSES ANGEBOT</p>
        <h2 className="font-display text-3xl md:text-5xl font-bold uppercase tracking-tighter text-white leading-[1.05]">
          Ein Projekt rund um<br />Haus & Grundstück?
        </h2>
        <p className="mt-4 max-w-lg text-sm md:text-base leading-relaxed text-white/60">
          Rufen Sie uns an oder schreiben Sie uns – Sie erhalten ein schnelles, transparentes
          und unverbindliches Angebot für Ihr Vorhaben in Gronau und Umgebung.
        </p>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: 28 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.6, delay: 0.1 }}
        className="flex flex-col sm:flex-row lg:flex-col gap-4 shrink-0"
      >
        <a
          data-testid="cta-band-call"
          href={PHONE_TEL}
          className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-brand px-8 py-4 text-sm font-bold tracking-wider text-black hover:bg-brand-bright transition-colors duration-300"
        >
          <Phone className="h-4 w-4" /> {PHONE_DISPLAY}
        </a>
        <button
          data-testid="cta-band-offer"
          onClick={() => scrollToId("kontakt")}
          className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-white/30 px-8 py-4 text-sm font-bold tracking-wider text-white hover:bg-white hover:text-black transition-colors duration-300"
        >
          ANGEBOT ANFRAGEN <ArrowRight className="h-4 w-4" />
        </button>
      </motion.div>
    </div>
  </section>
);
